import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import funcSleep from "../../../components/funcSleep";
import dayjs from "dayjs";
import IconDraft from "../../../img/home/icon-draft";
import { toast } from "react-toastify";
import { ApiEndpoints, reqPostDownloadFile, reqPostNew } from "../../../config/apiClient";
import { getCookie } from "../../../config/cookies";
import IconDownload from "../../../img/home/icon-download";
import modalStyles from "../styles/modalEmitirVarios.module.css"

interface iPropsModal {
    show: boolean,
    handleClose: any,
    notas: any[],
}

//create your forceUpdate hook
function useForceUpdate(){
    // eslint-disable-next-line
    const [value, setValue] = useState(0);
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}

export default function NfModalDownloadVarios({show, handleClose, notas}: iPropsModal) {

    const [downloading, setDownloading] = useState<boolean>(false)
    const [qtdNotasProgresso, setQtdNotasProgresso] = useState<number>(0)
    const forceUpdate = useForceUpdate();

    async function handleCloseButton() {
        setDownloading(false)
        setQtdNotasProgresso(0)
        var button:any = document.getElementById("btnCancelarDownloadLoteNotas")
        button.removeAttribute("disabled")
        handleClose()
    }

    async function handleDownloadNotas() {
        if (!window.confirm("Deseja fazer o download das notas selecionadas?")) {
            return
        }
    
        setQtdNotasProgresso(0)
    
        let notasAux = []
        for (let reg of notas) {
            notasAux.push({
                status: 'downloading',
                nota: reg.nota
            })
        }
    
        setDownloading(true)
        await funcSleep(500)
    
        await handleDownload(notasAux)
    
        await funcSleep(500)
        setDownloading(false)
    }

    async function handleDownload(notasAux:any[]) {
        console.log(`TODAS NFS`)
        console.log(notasAux)

        if (notasAux.length === 0) {
            toast.warning(`Não há notas emitidas para download!`, {
                containerId: 1,
                position: 'bottom-center',
                theme: 'dark'
            })
            return
        }

        var button:any = document.getElementById("btnCancelarDownloadLoteNotas")
        button.removeAttribute("disabled")

        setDownloading(true)
        const lista_arquivos = await baixarListaArquivos(notasAux, [])

        button.removeAttribute("disabled")
        setQtdNotasProgresso(0)

        if (lista_arquivos.length === 0) {
            toast.error('Não foi possível realizar o download!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setDownloading(false)
            return
        }
        console.log(lista_arquivos)
        
        const downloadDados = {
            paths: lista_arquivos
        }
        let arquivo = `Notas-Fiscais.zip`
        let apiDownload = await reqPostDownloadFile(ApiEndpoints.nfsDownloadLista, downloadDados, arquivo)

        if (apiDownload.status === 200) {
            toast.success('Download realizado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Não foi possível realizar o download, verifique com o suporte ou entre em contato mais tarde!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setDownloading(false)

    }

    async function baixarListaArquivos(notas:any[], lista_arquivos:string[]):Promise<string[]> {

        let qtdNotasProgressoAux = qtdNotasProgresso

        for (let reg of notas) {
            var button:any = document.getElementById("btnCancelarDownloadLoteNotas")
            if (button.disabled === true) {
                return []
            }

            let dadosDownload = {
                id_nota: reg.nota.id_nota,
                ambiente: reg.nota.ambiente.ambiente,
                codigo_verificacao: reg.nota.codigo_verificacao,
                tipo_arquivo: "pdf",
            }
            let api = await reqPostNew(ApiEndpoints.nfsDownloadPath, dadosDownload)

            if (api.status === 200) {
                lista_arquivos.push(api.data.message)
                qtdNotasProgressoAux = qtdNotasProgressoAux + 1
                setQtdNotasProgresso(qtdNotasProgressoAux)
                forceUpdate()
            }
            await funcSleep(500)
        }

        return lista_arquivos
    }

    async function handleCancelarNotas() {
        // setCancelarNotas(true)
        // forceUpdate()
        var button:any = document.getElementById("btnCancelarDownloadLoteNotas")
        button.setAttribute("disabled", "true")
    }

    return (
        <Modal
        show={show}
        onHide={() => {handleCloseButton()}}
        backdrop="static"
        keyboard={false}
        size="xl"
        id="modal_nf_emitir_varios"
    >
        <Modal.Header closeButton>
            <Modal.Title>Download NFs Selecionadas:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div style={{ display: "flex", alignContent: "center", alignItems: "center" }}>
                <Button variant="success" disabled={downloading} onClick={() => { handleDownloadNotas() }} style={{display: "inline"}}>Download Notas</Button>
                
                <Button id="btnCancelarDownloadLoteNotas" variant="danger" disabled={false} onClick={() => { handleCancelarNotas() }} style={{display: downloading ? "inline" : "none", marginLeft: "15px"}}>Cancelar</Button>
                
                <p style={{display: "inline", marginLeft: "10px"}}>({notas.length}) Notas Selecionadas</p>
                
                { downloading && ( <div style={{display: "flex", marginLeft: "15px" }}><br></br><LoadingWidget mensagem="Aguarde, baixando Notas" qtdEmitido={qtdNotasProgresso} qtdTotal={notas.length} /></div> ) }
            </div>

            <br></br>
            <ListaNotas notasEmitir={notas} />

            <br></br>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => {handleCloseButton()}}>Fechar</Button>
        </Modal.Footer>
    </Modal>
    )

}

function ListaNotas(props:any) {

    return (
        <div id="notas_ha_emitir">
            {
                props.notasEmitir.map((reg:any, idx:any) => {
                    let cidade = ""
                    if (reg.nota.cod_cidade !== null) {
                        cidade = ` (${reg.nota.cod_cidade.nome}-${reg.nota.cod_cidade.uf})`
                    }
                    let valor:string = ""
                    if (reg.nota.valor_base !== null) {
                        valor = reg.nota.valor_base
                    }
                    if (valor === "") {
                        valor = reg.nota.valor_servicos
                        valor = valor.replaceAll(",", "")
                    }
                    return (
                        <div key={idx}>
                            <div className={modalStyles.notas_ha_emitir_item}>
                                <IconDraft className={modalStyles.iconDraft} />
                                <p>Número {reg.nota.numero_nf}{cidade} {valor} | {reg.nota.id_cliente.nome} | {dayjs(reg.nota.data_servico).format("DD/MM/YYYY")} Situação {reg.nota.cod_serv.iss_incidencia_municipio_prestador === 0 ? 'Tributada' : 'Retido'}</p>
                                <BtnDownloadNf reg={reg} />
                            </div>
                            
                        </div>
                    )
                })
            }
        </div>
    )
}

interface iPropsBtnDownload {
    reg: any
}
function BtnDownloadNf({reg}: iPropsBtnDownload) {

    const [downloading, setDownloading] = useState<boolean>(false)

    async function handleDownload() {
        let dadosDownload = {
            id_nota: reg.nota.id_nota,
            ambiente: reg.nota.ambiente.ambiente,
            codigo_verificacao: reg.nota.codigo_verificacao,
            tipo_arquivo: "pdf",
        }
        setDownloading(true)
        await download(dadosDownload, reg.nota)
    }

    async function download(dadosDownload:any, nfDados:any) {
    
        return new Promise(function (resolve, reject) {
            var token = getCookie('token')
            var id_usuario = getCookie('id_user')
            let request = new XMLHttpRequest();
        
            request.responseType = "blob";
            request.open("POST", dadosDownload.tipo_arquivo === "pdf" ? ApiEndpoints.nfsDownloadPDF.endpoint : ApiEndpoints.nfsDownloadXML.endpoint, true)
            request.setRequestHeader("Content-Type", "application/json")
            request.setRequestHeader("Authorization", `Bearer ${token}`)
            request.setRequestHeader("id_usuario", id_usuario)
            request.send(JSON.stringify(dadosDownload))
        
            request.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const imageURL = window.URL.createObjectURL(this.response)
                    const anchor = document.createElement("a")
                    anchor.href = imageURL
                    console.log(nfDados)
                    let cidade = ""
                    if (nfDados.cod_cidade !== null) {
                        cidade = ` (${nfDados.cod_cidade.nome}-${nfDados.cod_cidade.uf})`
                    }
                    let valor:string = ""
                    if (nfDados.valor_base !== null) {
                        valor = nfDados.valor_base
                    }
                    if (valor === "") {
                        valor = nfDados.valor_servicos
                        valor = valor.replaceAll(",", "")
                    }
                    anchor.download = `NFe ${nfDados.numero_nf}${cidade} - ${valor} - ${nfDados.id_cliente.nome}.${dadosDownload.tipo_arquivo === 'pdf' ?'pdf' : 'xml'}`
                    document.body.appendChild(anchor)
                    anchor.click()
                    toast.success('Download realizado com sucesso!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setDownloading(false)
                    resolve('')
                } else if (this.status === 401 || this.status === 400) {
                    toast.error(`Erro Download! NF ${nfDados.numero_nf}`, {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setDownloading(false)
                    resolve('')
                }
            }
        })
    
    }

    return (
        <div className="div-row">
            <div className="div-row" style={{cursor: "pointer", minWidth: "200px"}} onClick={() => {
                if (!downloading) {
                    handleDownload()
                }
            }}>
                { downloading && <Spinner animation="border" role="status" size="sm" style={{marginLeft: "10px", marginRight: "10px"}}></Spinner> }
                { !downloading && <IconDownload className={modalStyles.iconDownload} /> }
                <p style={{fontWeight: 'bold'}}>Download PDF</p>
            </div>
        </div>
    )
}

function LoadingWidget(props:any) {
    return (
        <div className="div-row">
            <Spinner animation="border" role="status" style={{marginRight: "10px"}}>
            <span className="visually-hidden"></span>
            </Spinner>
            <p style={{fontWeight: 'bold'}}>{props.mensagem} {props.qtdEmitido}/{props.qtdTotal} ...</p>
        </div>
    )
}
